module.exports = __webpack_public_path__ + "img/2.30a09f4e.png";